export default function last(arr) {
  return arr[arr.length - 1];
}